const MAX_LEVEL = 10;

const limitStack = (stack: string) =>
  stack.split('\n').slice(0, MAX_LEVEL).join('\n');

export default limitStack;
